import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

merge(changePasswordStyles, {
    passwordGridContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 400px !important;
                        `,
                    ],
                    "min",
                )}
        `,
        gap: 10,
    },
});
